import React from 'react'
import { Flex } from 'reflexbox/styled-components'
import { Title } from 'components/Typography'
import PartnerMyPackagesTable from 'containers/PartnerMyPackagesTable'

const MyPackages = () => {
  return (
    <Flex flexDirection='column' alignItems='center' justifyContent='space-between'>
      <Flex width={1} justifyContent='space-between' mb={24}>
        <Title as='h3'>Meus pacotes</Title>
      </Flex>
      <PartnerMyPackagesTable />
    </Flex>
  )
}

export default MyPackages
